// @flow
import React from 'react';
import './QuoteContent.scss';

type Props = {
  body: string,
  theme: string,
  thumbnail: ?string,
  onSetToc: (toc: any) => void,
  onActivateHeading: (headingId: string) => void,
};

const QuoteContent = ({ body }: Props) => (
  <div className="QuoteContent">
    <div className="contents" dangerouslySetInnerHTML={{ __html: body }}></div>
  </div>
);

QuoteContent.Placeholder = () => (
  <div className="QuoteContent placeholder">
    <div className="quote-thumbnail">
      <div className="fake-img" />
    </div>
    <div className="contents">
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '75%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
      <div className="line-breaker" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" />
      <div className="gray-block" style={{ width: '40%' }} />
    </div>
  </div>
);

export default QuoteContent;



// WEBPACK FOOTER //
// ./src/components/quote/QuoteContent/QuoteContent.js